import type { CSSProperties } from 'react';

import ArrowRight from '@assets/localIcons/ArrowRight';
import Back from '@assets/localIcons/Back';
import Date from '@assets/localIcons/Date';
import LocationMark from '@assets/localIcons/LocationMark';
import Phone from '@assets/localIcons/Phone';
import Pta from '@assets/localIcons/Pta';
import Route from '@assets/localIcons/Route';
import Star from '@assets/localIcons/Star';
import Time from '@assets/localIcons/Time';

const localIcons = {
	ArrowRight,
	Back,
	Date,
	LocationMark,
	Phone,
	Pta,
	Route,
	Star,
	Time,
};
export type IconName = keyof typeof localIcons;

type Props = {
	name: IconName;
	size?: number | string;
	color?: string;
	style?: CSSProperties;
	strokeWidth?: number;
};

const Icon: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
	const { name, size, color, style, strokeWidth } = props;
	const IconComponent = localIcons[name];

	if (!IconComponent) {
		return null;
	}

	return <IconComponent width={size} height={size} style={style} strokeWidth={strokeWidth} color={color} />;
};

export default Icon;
